/**
 * Fatiado de ReviewPanel.tsx (limite de linhas, QA 5640804090 r.3): a AÇÃO
 * PRINCIPAL do fundo da revisão — revisão não enviada ⇒ só o botão de
 * revisão; limpa ⇒ modo + «Importar». «Importar» desativado por falta de
 * confirmação de moeda mostra o atalho para o cartão (revisão UX).
 */
import { useI18n } from '../../lib/i18n.js'
import { Button } from '../../components/ui/index.js'

export function ReviewFooterActions({
  hasUnsubmittedReview,
  pendingCount,
  reviewPending,
  onSubmitReview,
  mode,
  onModeChange,
  canCommit,
  currencyNeedsConfirm,
  commitPending,
  onCommit,
}: {
  hasUnsubmittedReview: boolean
  pendingCount: number
  reviewPending: boolean
  onSubmitReview: () => void
  mode: 'append' | 'replace'
  onModeChange: (mode: 'append' | 'replace') => void
  canCommit: boolean
  currencyNeedsConfirm: boolean
  commitPending: boolean
  onCommit: () => void
}) {
  const { t } = useI18n()
  return (
    <>
      {hasUnsubmittedReview ? (
        <div className="rounded-2xl border-2 border-amber-300 bg-amber-50 p-4 space-y-2">
          <p className="text-sm text-gray-700">{t('admin.import.review_submit_hint')}</p>
          <Button
            loading={reviewPending}
            data-testid="import-review-submit"
            onClick={onSubmitReview}
            className="w-full"
          >
            {t('admin.import.review_submit')}
            {pendingCount > 0 ? ` (${pendingCount})` : ''}
          </Button>
        </div>
      ) : (
        <div className="rounded-2xl border border-gray-200 bg-white p-4 space-y-3">
          <p className="text-sm font-bold text-gray-900">{t('admin.import.mode')}</p>
          <div className="flex gap-4 text-sm">
            <label className="flex items-center gap-2 min-h-11">
              <input
                type="radio"
                data-testid="import-mode-append"
                checked={mode === 'append'}
                onChange={() => onModeChange('append')}
              />
              {t('admin.import.append')}
            </label>
            <label className="flex items-center gap-2 min-h-11">
              <input
                type="radio"
                data-testid="import-mode-replace"
                checked={mode === 'replace'}
                onChange={() => onModeChange('replace')}
              />
              {t('admin.import.replace')}
            </label>
          </div>
          {mode === 'replace' && (
            <p className="text-xs text-red-600">{t('admin.import.replace_warn')}</p>
          )}
          {/* revisão UX: «Importar» desativado sem explicação não diz o que
              falta — o botão faz scroll E move o foco para o cartão */}
          {!canCommit && currencyNeedsConfirm && (
            <button
              type="button"
              data-testid="import-currency-commit-hint"
              onClick={() => {
                const card = document.getElementById('import-currency-card')
                card?.scrollIntoView({ behavior: 'smooth', block: 'start' })
                card?.focus()
              }}
              className="text-sm text-amber-900 underline font-medium min-h-11 inline-flex items-center"
            >
              {t('admin.import.currency_confirm_to_import')}
            </button>
          )}
          <Button
            disabled={!canCommit}
            loading={commitPending}
            id="import-commit"
            data-testid="import-commit"
            onClick={onCommit}
          >
            {commitPending ? t('admin.import.committing') : t('admin.import.commit')}
          </Button>
        </div>
      )}
    </>
  )
}
